import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'TrendDecoration',
  components: {
    MdmStripe
  },
  props: {
    trends: {
      type: Object,
      required: true
    }
  },
  computed: {
    trend() {
      const [trend = {}] = Object.values(this.trends);
      return trend;
    }

  }
};